const isPlainObject = (value) => {
  return (
    value &&
    typeof value === "object" &&
    value.constructor === Object &&
    Object.getPrototypeOf(value) === Object.prototype
  );
};

const appendToFormData = (formData, key, value) => {
  // undefined = the field is not participating in this request (untouched file, partial form) => skip it.
  if (value === undefined) {
    return;
  }
  // null or "" = the user explicitly cleared the value => send the key empty.
  // ConvertEmptyStringsToNull turns it into null on the backend.
  if (value === null || value === "") {
    formData.append(key, "");
    return;
  }
  if (value instanceof File || value instanceof Blob) {
    formData.append(key, value);
  } else if (value instanceof Date) {
    formData.append(key, value.toISOString());
  } else if (typeof value === "boolean") {
    // "true"/"false" fail Laravel's `boolean` rule — it only accepts 1/0/"1"/"0"
    // (and real booleans, which multipart cannot carry).
    formData.append(key, value ? "1" : "0");
  } else if (typeof value === "number") {
    if (!isNaN(value)) formData.append(key, value.toString());
  } else {
    formData.append(key, value.toString());
  }
};

export const convertToFormData = (obj, formData = new FormData(), parentKey = "") => {
  Object.entries(obj).forEach(([key, value]) => {
    const propName = parentKey ? `${parentKey}[${key}]` : key;
    if (Array.isArray(value)) {
      if (value.length === 0) {
        // An empty collection means the user cleared it. FormData cannot carry an empty
        // array, so send an explicit marker (key[]="") — the backend clears the
        // relationship/file, and NormalizeEmptyArrayMarkers collapses it to [] for plain
        // array/json columns.
        formData.append(`${propName}[]`, "");
      } else {
        value.forEach((item, index) => {
          const itemKey = `${propName}[${index}]`;
          isPlainObject(item)
            ? convertToFormData(item, formData, itemKey)
            : appendToFormData(formData, itemKey, item);
        });
      }
    } else if (isPlainObject(value)) {
      convertToFormData(value, formData, propName);
    } else {
      appendToFormData(formData, propName, value);
    }
  });

  return formData;
};

export const measureFormData = (formData) => {
  let bytes = 0;
  let hasFiles = false;
  for (const [, value] of formData.entries()) {
    if (value instanceof File || value instanceof Blob) {
      hasFiles = true;
      bytes += value.size;
    } else {
      bytes += new Blob([value]).size;
    }
  }
  return { hasFiles, bytes };
};
